module.exports = __webpack_public_path__ + "images/143_160.jpg";